// Configurable brand list for "Shop by Brand".
export const brands = [
  { id: "apple", name: "Apple" },
  { id: "samsung", name: "Samsung" },
  { id: "oneplus", name: "OnePlus" },
  { id: "google", name: "Google" },
  { id: "vivo", name: "Vivo" },
  { id: "oppo", name: "OPPO" },
  { id: "xiaomi", name: "Xiaomi" },
  { id: "realme", name: "Realme" },
];

export const brandName = (id) =>
  brands.find((b) => b.id === id)?.name || id;
